import InterestedUsers from "components/SharedSafari/view/intrestedusers/InterestedUsers";
import React from "react";
import {Container, Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from "react-router-dom";

const DiscussionSkeleton = () => {
    return (
        <section className="safari_wrapper margin_bottomfooter pt-3">
            <Container>
                <Row className="mb-5 pb-lg-5 pb-0">
                    <Col lg={9} className="mb-4">
                        <div className="formbg">
                            <button
                                className="discussionTabs"
                                style={{
                                    backgroundColor: "var(--background-primary)",
                                    cursor: "default",
                                }}
                                value=""
                            >
                                <Skeleton width={100} height={20} />
                            </button>
                            <div className="comments_safari bg-white">
                                <div className="top_replysafari px-3">
                                    <div className="comments-persons">
                                        <div className="postcomment d-flex gap-2">
                                            <div className="avatar me-3">
                                                <Skeleton circle width={50} height={50} />
                                            </div>
                                            <div className="text_com" style={{ flex: 1 }}>
                                                <h6 className="nameavatr">
                                                    <Skeleton width={120} height={20} />
                                                </h6>
                                                <div className="profile-description">
                                                    <div className="text show-more-height">
                                                        <Skeleton count={2} />
                                                    </div>
                                                    <div className="show-more">
                                                        <Skeleton width={60} height={16} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg={3} className="mb-lg-0 mb-3">
                        <InterestedUsers/>
                    </Col>
                </Row>
                <Row className="pb-5 d-lg-none">
                    <Col className="col-12 text-center">
                        <div className="joinshareView mt-md-0 mt-3">
                            <Link
                                href="/sharedsafari"
                                className="btn_shareView pakage"
                                data-pjax="0"
                            >
                                {" "}
                                <i className="fa-solid fa-arrow-left me-2"></i> Back
                            </Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default DiscussionSkeleton;
